import React, { FC } from 'react';
import PolygonItem, { PolygonItemType } from './polygon-item';
import { CoKitchenPolygons } from 'models/cokitchen.model';
import { POLYGON_COLORS } from 'utils/constants';

type PolygonCardProps = {
  polygons: CoKitchenPolygons[];
  setActivePolygon: (polygon: CoKitchenPolygons) => void;
  list: PolygonItemType[];
};

const PolygonCard: FC<PolygonCardProps> = ({ polygons, list, setActivePolygon }) => {
  const sortedPolygons = polygons?.sort((a, b) => b.updated_at.localeCompare(a.updated_at));
  return (
    <div className='overflow-y-auto min-w-[375px] rounded-2xl border border-[#EFF0F0] '>
      <h2 className='text-sm text-gray-5 uppercase tracking-wider py-3 px-6 border-b border-[#EFF0F0]'>
        Polygons
      </h2>

      <div className='py-5 px-6 space-y-4 h-[calc(100%-90px)] max-h-[495px] overflow-auto '>
        {sortedPolygons?.map((polygon, index) => (
          <PolygonItem
            list={list}
            onClick={() => setActivePolygon(polygon)}
            key={index}
            color={POLYGON_COLORS[index].color_code}
            name={polygon.name}
          />
        ))}
      </div>
    </div>
  );
};

export default PolygonCard;
